<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Fault Analysis : <span class="cursor-as-pointer mr-2 ml-2" @click="jumpToNotification(faultName,'title')">{{faultName}}</span> in <span class="cursor-as-pointer ml-2" @click="jumpToNotification(equipmentName,'equipment_name')">{{equipmentName}}</span> <span v-if="highlightTime">on {{highlightTime}}</span>
                    <v-spacer></v-spacer>
                    <date-range-selector class="mr-4" v-model="dateRange" @change="handleDateChange()" ></date-range-selector>

                    <v-btn
                           @click="exportAll()"
                    >
                        Export all as PDF
                    </v-btn>
                </v-card-title>
                <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 v-if="data1">
                        <vue-plotly disable-responsive  :data="data1" :layout="layout1" ref="feplot" :options="{}"/>
                    </v-flex>
                    <v-flex xs12>
                        <multi-plot-chart v-if="!loading&&variableList.length>0"
                                          ref="rvplot"
                                          :on-only="false"
                                          disable-responsive
                                          :date-range="dateRange"
                                          just-plot
                                          :variable-x="'timestamp'"
                                          :variables-list="variableList"
                                          :layout-overrides="{...layoutOverrides}"
                                          :type="'scatter'"
                        ></multi-plot-chart>
                    </v-flex>
                    <v-flex xs12 v-if="!loading&&fullVariableList">
                        <multi-plot-chart v-for="(unitVars,unitName) in fullVariableList" :key="unitName"
                                          :on-only="false"
                                          :date-range="dateRange"
                                          disable-responsive
                                          just-plot
                                          ref="plots"
                                          :variable-x="'timestamp'"
                                          :variables-list="unitVars"
                                          :layout-overrides="{height:unitVars.length>10 ? 800 : null,shapes:layoutOverrides.shapes,yaxis:{title:unitName,fixedrange: true},showlegend: true,legend:{...layoutOverrides.legend},xaxis:{...layoutOverrides.xaxis},hovermode:layoutOverrides.hovermode,hoverlabel:layoutOverrides.hoverlabel}"
                                          :type="'scatter'"
                        ></multi-plot-chart>
                    </v-flex>

                </v-layout>
                    <v-layout v-if="rule&&equipment&&equipment.floor" row wrap>
                        <v-spacer></v-spacer>
                        <v-btn
                                @click="openFaultComparison()"
                        >
                            View this rule on other equipments in {{equipment.floor}}
                        </v-btn>
                    </v-layout>

                </v-card-text>
            </v-card>
        </v-flex>





    </v-layout>
</template>

<script>
    import MultiPlotChart from "../components/MultiPlotChart"
    import exportAllToPDF from '../components/mixins/exportAllToPDF'
    import {getPoint,getRule,runRuleTest,callAPI} from '../helper'
    import VuePlotly from "../components/VuePlotly";
    import Plotly from 'plotly.js/dist/plotly'
    import DateRangeSelector from "../components/DateRangeSelector";
    import moment from 'moment'
    export default {
        name: 'FaultAnalysis',
        components: { MultiPlotChart,VuePlotly,DateRangeSelector},
        mixins:[exportAllToPDF],

        data () {
            return {
                loading:true,
                rule:null,
                equipment:null,
                dateRange: {start: null, end: null},
                equipmentName: null,
                faultDesc: null,
                highlightTime:null,
                relevantVariables:null,
                faultName:null,
                variableList:[],
                layoutOverrides:{},
                layout1:null,
                data1:null,
                points:[],
                plots:[],
                allVars:null,
                fullVariableList:null,
            }
        },
        methods:{
            jumpToNotification(value,facet) {
                let output = {
                    path: '/notification-breakdown',
                    query:{
                        rangeStart: this.dateRange.start,
                        rangeEnd: this.dateRange.end,
                    }
                }
                output.query[facet]=value
                this.$router.push(output)
            },
            handleDateChange(){
              this.renderPlots()
            },
            relayout(ed) {
                let plots=[]
                for (let item of this.$refs.plots){
                    if (item.$refs.plotly){
                        plots.push(item.$refs.plotly.$refs.container)
                    }
                }
                if(this.$refs.feplot){
                    plots.push(this.$refs.feplot.$refs.container)
                }
                if(this.$refs.rvplot){
                    plots.push(this.$refs.rvplot.$refs.plotly.$refs.container)
                }
                for (let plot of plots){
                    let x = plot.layout.xaxis;
                    if (x.range[0] !== ed["xaxis.range[0]"] || x.range[1] !== ed["xaxis.range[1]"]){
                        Plotly.relayout(plot, ed);
                    }
                }
            },
            doInitialReload(){
                let me=this;
                if(!me.$refs.feplot){
                    setTimeout(function(){ me.doInitialReload()}, 3000);
                } else {
                    Plotly.relayout(me.$refs.feplot.$refs.container,{
                        'xaxis.autorange': true
                    })
                }

            },
            initPlotlySync(){
                let plots=[]
                let me=this;
                if(!this.$refs.plots||(me.variableList.length>0&&(!this.$refs.rvplot||!this.$refs.rvplot.$refs.plotly))||(me.rule&&!this.$refs.feplot)){
                    setTimeout(function(){ me.initPlotlySync()}, 2000);
                } else {
                    for (let item of this.$refs.plots){
                        if (item.$refs.plotly){
                            plots.push(item.$refs.plotly.$refs.container)
                        }
                    }
                    if(this.$refs.feplot){
                        plots.push(this.$refs.feplot.$refs.container)
                    }
                    if(this.$refs.rvplot){
                        plots.push(this.$refs.rvplot.$refs.plotly.$refs.container)
                    }
                    me.plots=plots;
                    plots.forEach(div => {
                        div.on("plotly_relayout", ed=> {
                            if (!ed.autosize){
                                let newl={
                                    "xaxis.range[0]":div.layout.xaxis.range[0],
                                    "xaxis.range[1]":div.layout.xaxis.range[1],
                                }
                                me.relayout(newl);
                            }
                        });
                    });
                }



            },
            openFaultComparison(){
                this.$router.push({
                    path: '/fault-comparison',
                    query: {
                        rangeStart:this.dateRange.start,
                        rangeEnd:this.dateRange.end,
                        floor:this.equipment.floor,
                        rule:this.rule.title,
                    }
                })
            },
            async renderPlots(){
                let me=this;
                me.loading=true
                me.data1=null
                // me.othersFEData=null
                if(this.faultDesc){
                    getRule({
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    }).then(function (rules) {
                        for (let rule of rules.result){
                            if (rule.title==me.faultName){
                                me.rule=rule
                                me.faultDesc=me.rule.desc
                                callAPI('issue/',
                                    {
                                        'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                        'issue': rule.title,
                                        'equipment_name': me.equipmentName,
                                        'date_range': [me.dateRange.start, me.dateRange.end]
                                    }
                                ).then(function (issueRes) {
                                    let df=issueRes.data
                                    let timeAxis=[];
                                    let ts=moment(me.dateRange.start).format('YYYY-MM-DD HH:mm:ss')
                                    let end=moment(me.dateRange.end).format('YYYY-MM-DD HH:mm:ss')
                                    while (ts<=end){
                                        timeAxis.push(ts)
                                        ts=moment(ts).add(me.$store.getters.minutesBetweenSamples,'minutes').format('YYYY-MM-DD HH:mm:ss')
                                    }
                                    let refinedDf={
                                        x:timeAxis,
                                        y:[...new Set(df['issue'])],
                                        z:[]
                                    }
                                    for (let issue of refinedDf.y){
                                        let newZ=new Array(timeAxis.length).fill(false);
                                        for (let index in df['issue']){
                                            if(df['issue'][index]===issue){
                                                newZ[timeAxis.indexOf(df['timestamp'][index])]=true;
                                            }
                                        }
                                        refinedDf.z.push(newZ)
                                    }
                                    if(!refinedDf.z[0]){
                                        refinedDf.z[0]=new Array(timeAxis.length).fill(false)
                                    }
                                    me.data1 = [
                                        {
                                            x: refinedDf.x,
                                            y: refinedDf.z[0],
                                            name: 'Rule evaluation',
                                            type: 'scatter',
                                            mode: 'none',
                                            fill: 'tozeroy',
                                            fillcolor:'rgb(214, 39, 40)',
                                            line: {shape: 'hv'}
                                        },
                                    ]
                                    me.layout1={
                                        height:210,
                                        plot_bgcolor:'rgb(31, 119, 180)',
                                        title:'Rule evaluation : '+me.faultDesc,
                                        yaxis: {
                                            title: 'Rule',
                                            fixedrange: true,
                                            categoryorder: 'array',
                                            range: [0, 1],
                                            showticklabels:false,
                                            categoryarray: ["false", "true"]
                                        },
                                        xaxis: {
                                            title: 'Time ',
                                        },
                                        hoverlabel: { bgcolor: "#606060" },
                                    }
                                    setTimeout(function(){ me.initPlotlySync()}, 2000);
                                    setTimeout(function(){ me.doInitialReload()}, 3000);
                                })
                                break
                            }
                        }
                    })
                } else {
                    setTimeout(function(){ me.initPlotlySync() }, 2000);
                }
                let df = await getPoint({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                })
                this.points = df['result']
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    if (this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name===this.equipmentName){
                        this.equipment = this.$store.state.pointsListStore.pointsList.equipment_details[i];
                        this.allVars=this.$store.state.pointsListStore.pointsList.sensors[i]
                        break
                    }
                }
                let variableList=[];
                for (let varName of this.relevantVariables){
                    variableList.push({
                        equipment_name: this.equipmentName,
                        facility_name: this.$store.state.pointsListStore.facility_name,
                        name: varName,
                    })
                }
                this.variableList=variableList;
                if(this.allVars){
                    let newVarList={};
                    for (let varName of this.allVars){
                        let unit = this.getUnit(varName)
                        if (!newVarList[unit]) {
                            newVarList[unit] = [];
                        }
                        newVarList[unit].push({
                            equipment_name: this.equipmentName,
                            facility_name: this.$store.state.pointsListStore.facility_name,
                            name: varName,
                        })
                    }
                    this.fullVariableList=newVarList
                }
                this.layoutOverrides={
                    title:"Relevant variables",
                    xaxis: {
                        title: 'Time ',
                    },
                    yaxis:{
                        fixedrange: true
                    },
                    showlegend:true,
                    legend: {
                        orientation:'h',
                        x: 0.1,
                        y: -0.5
                    },
                    hoverlabel: {
                        namelength: -1
                    },
                    hovermode:"x",
                    shapes: this.highlightTime ? [
                        {
                            type: 'line',
                            x0:this.highlightTime,
                            y0: 0,
                            x1: this.highlightTime,
                            y1: 1,
                            yref: 'paper',
                            line:{
                                color: 'red',
                                width: 4,
                            }
                        }
                    ] : [],
                }
                this.loading=false
            },
            async exportAll(){
                let plots=[...this.$refs.plots]
                if(this.$refs.rvplot){
                    plots.unshift(this.$refs.rvplot)
                }
                if(this.$refs.feplot){
                    plots.unshift(this.$refs.feplot)
                }
                this.exportAllItems(plots);
            },
            getUnit(varName){
                for (let point of this.points){
                    if(point.sensor_name===varName&&point.equipment_name===this.equipmentName){
                        if(point.unit){return point.unit}
                        break
                    }
                }
                if(varName.toLowerCase().includes("tem")){
                    return "°C"
                } else if(varName.toLowerCase().includes("press")){
                    return "kPa"
                } else if(varName.toLowerCase().includes("status")){
                    return "status"
                } else if(varName.toLowerCase().includes("_hr")){
                    return "hour"
                }
                return "Unknown";
            }
        },
        beforeMount(){
            this.equipmentName = _.get(this.$route.query,'equipmentName', null)
            let endTest=moment(_.get(this.$route.query,'rangeEnd')).add(5,'hours').format('YYYY-MM-DD HH:mm:ss')
            let now=moment().format('YYYY-MM-DD HH:mm:ss')
            this.dateRange={
                start:moment(_.get(this.$route.query,'rangeStart')).subtract(5,'hours').format('YYYY-MM-DD HH:mm:ss'),
                end:endTest>now ? now : endTest
            }
            this.highlightTime =  _.get(this.$route.query,'highlightTime', null)
            this.faultDesc =  _.get(this.$route.query,'faultDesc', null)
            let relvs=_.get(this.$route.query,'relevantVariables', null)
            this.relevantVariables = relvs&&relvs!=='0'&&relvs!=='' ? relvs.split(',') : [];
            this.faultName =  _.get(this.$route.query,'faultName', '')
        },
        mounted(){
            this.renderPlots()
        },





    }
</script>
